<template>
  <b-modal id="modal-cadastrar-topico" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title" v-if="isEdicao">Editar tópico</h5>
      <h5 class="modal-title" v-else>Adicionar tópico</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-cadastrar-topico')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <form>
      <div class="row">

        <div class="col-12 col-md-6">
          <form-group id="nomeTopico"  label="Nome do Tópico *" :text="{ required: 'Obrigatório informar o nome do tópico' }" :field="$v.topico.topico">
            <input type="text" class="form-control" id="nomeTopico" placeholder="" v-model="topico.topico" value="" />
          </form-group>
        </div>
        <div class="col-12 col-md-6">
          <form-group id="descricaoTopico"  label="Descrição *" :text="{ required: 'Obrigatório informar a descrição do tópico' }" :field="$v.topico.descricao">
            <input type="text" class="form-control" id="descricaoTopico" placeholder="" v-model="topico.descricao" />
          </form-group>
        </div>
      </div>
      <div class="text-center">
        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
          <button class="btn btn-primary mr-3" type="button" @click="editarTopico" v-if="isEdicao">Salvar</button>
          <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-cadastrar-topico')">Cancelar</a>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import Swal from 'sweetalert2'
import TopicoAPI from '@/api/topico-api'
import { required } from 'vuelidate/lib/validators'
import FormGroup from '@/core/components/FormGroup'
import ResponseUtils from '@/core/util/response-utils'

export default {
  name: 'ModalCadastroTopico',
  components: {
    FormGroup
  },
  inheritAttrs: false,
  props: {
    curso_id: Number,
    modulo_id: Number,
    licao_id: Number,
    topicoEdicao: Object,
    topico_array_prop: Array
  },
  data () {
    return {
      topico: {
        topico: '',
        descricao: ''
      },
      topico_array: []
    }
  },

  computed: {
    isEdicao: function () {
      return this.topicoEdicao && this.topicoEdicao.id > 0
    }
  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.$v.$reset()

      this.topico_array = this.topico_array_prop
      if (this.topicoEdicao) {
        this.topico = Object.assign({}, this.topicoEdicao)
      } else {
        this.topico = {
          topico: '',
          descricao: ''
        }
      }
    })
  },

  validations: {
    topico: {
      topico: { required },
      descricao: { required }
    }
  },

  methods: {
    show: function () {
      this.$bvModal.show('modal-cadastrar-topico')
    },

    editarTopico: function () {
      this.$v.topico.$touch()
      if (!this.$v.topico.$invalid) {
        const loader = this.$loading.show()

        TopicoAPI.editar(this.topico).then(data => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Tópico atualizado com sucesso!'
          }).then(() => {
            this.$bvModal.hide('modal-cadastrar-topico')
            this.topico_array.map(topico => {
              if (this.topicoEdicao.id === topico.id) {
                Object.assign(topico, this.topico)
              }
            })
            this.$emit('topicoEditado', this.topico_array)
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    }
  }
}
</script>
<style>
  div.modal-conta i.glyphicon-calendar{
    font-size: inherit;
  }
</style>
